<template>
    <VIPCheckIDAndBD
        v-model:id="no"
        v-model:bd="birthday"
        @postApi="postApi"
    />
    <Loading :isLoading="isLoading" />
</template>

<script>
import { reactive, toRefs, inject } from 'vue';
import { useRouter } from 'vue-router';
import routeName from '@/router/constant.js';
import { useStore } from 'vuex';
import VIPCheckIDAndBD from '@/components/template/VIPCheckIDAndBD.vue';
import { postLoginVIP, postInitVIP } from '@/apis/vipBirth';
import aplCatlCode from '@/json/aplCatlCode';

export default {
    components: {
        VIPCheckIDAndBD
    },
    setup() {
        const $vfm = inject('$vfm');
        const store = useStore();
        const router = useRouter();
        const users = reactive({
            no: '',
            noErrorMsg: '',
            birthday: '',
            source: 'VIP',
            key: router?.query?.key,
            isLoading: false,
        });

        const postApi = async (canPost) => {
            if (canPost) {
                users.isLoading = true;
                if (await login()) {
                    if (await init()) {
                        users.isLoading = false;
                        router.push({
                            name: routeName.VIP_INFO
                        });
                    }
                } else {
                    users.isLoading = false;
                }
            }
        };

        const openPopup = (errorMessage) => {
            store.dispatch('vipBirth/clearMember');
            $vfm.show({
                component: 'DialogBase',
                params: {
                    title: '系統提示',
                    content: errorMessage || '系統忙碌中，請稍後再試',
                    confirmButton: '確認',
                    cancelButton: null,
                    closeicon: true,
                },
                on: {
                    confirm() {
                        $vfm.hide('DialogBase');
                    },
                    closed() {
                        $vfm.hide('DialogBase');
                    },
                }
            });
        };
        (() => {
            store.dispatch('permissions/clearAll');
        })();

        // 登入
        const login = () => {
            const data = {
                id: users.no,
                birthday: users.birthday.split('/').join(''),
                source: users.source,
                key: users.key,
            };
            return postLoginVIP(data).then(res => {
                store.dispatch('vipBirth/setMember', res.data);
                store.dispatch('permissions/setAuthExternal', 'Y');
                store.dispatch('permissions/setUserInfo', res.data);
                return true;
            }).catch(err => {
                openPopup(err.data?.errorMessage);
            });
        };

        // 重置交易項目取得transactionUniqueId
        const init = () => {
            return postInitVIP().then(res => {
                store.dispatch('permissions/setTransactionId', res.data.transactionUniqueId);
                store.dispatch('permissions/setAplCatl', aplCatlCode.VIP);
                return true;
            }).catch(err => {
                openPopup(err.data.errorMessage);
            });
        };

        return {
            ...toRefs(users),
            postApi
        };
    },
};
</script>
